
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myalbums/add",
      function () {
        return require("private-next-pages/myalbums/add/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myalbums/add"])
      });
    }
  